<template>
    <BreadCrumb PageTitle="Salle de Composition" />
    <CompositionQuiz />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import CompositionQuiz from "@/components/Composition/CompositionQuiz.vue";
  
    export default defineComponent({
      name: "CompositionQuizPage",
      components: {
        BreadCrumb,
        CompositionQuiz,
      },
    });
  </script>